export default {"src":"/_next/static/media/HolisticCareApproachgastro.cc1de101.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};